import { Component, OnInit } from '@angular/core';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatToolbarModule } from '@angular/material/toolbar';
import { Router } from '@angular/router';

@Component({
    selector: 'app-disclosure',
    imports: [ MatToolbarModule, MatGridListModule],
    templateUrl: './disclosure.component.html',
    styleUrls: ['./disclosure.component.css'],
})
export class DisclosureComponent implements OnInit {

  constructor(private router: Router) { }

  ngOnInit(): void {
  }

  back() {
    this.router.navigate(['home']);
  }
}
